/**
 * MIRA Switch Component
 * Wraps Shadcn Switch with MIRA design system styles
 */

import React from 'react';
import { Switch as ShadcnSwitch } from '@/components/ui/switch';
import { cn } from '@/lib/utils';
import styles from '@/styles/components/switch.module.css';

export const Switch = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnSwitch
        ref={ref}
        className={cn(styles.miraSwitch, className)}
        {...props}
      />
    );
  }
);

Switch.displayName = 'MiraSwitch';
